import { render, staticRenderFns } from "./GifSearch.vue?vue&type=template&id=1834f395&scoped=true&lang=pug"
import script from "./GifSearch.vue?vue&type=script&lang=js"
export * from "./GifSearch.vue?vue&type=script&lang=js"
import style0 from "./GifSearch.vue?vue&type=style&index=0&id=1834f395&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1834f395",
  null
  
)

export default component.exports